import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

/** Enterprise pages exist only in enterprise mode (an enterprise token). */
export function EnterpriseRoute({ children }) {
  const mode = useSelector((state) => state.session.mode);
  if (mode !== 'enterprise') return <Navigate to="/" replace />;
  return children;
}

// Pages that are about the person, not an organization: still open in
// enterprise mode.
const OPEN_IN_ENTERPRISE = new Set(['/help', '/settings/account']);

/** True when `pathname` may render in enterprise mode. */
export function isEnterprisePath(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return path === '/enterprise' || path.startsWith('/enterprise/') || OPEN_IN_ENTERPRISE.has(path);
}

/** In enterprise mode every protected page outside /enterprise (and the
 *  personal pages above) leads back to it: the synthetic org has no fleet
 *  routes to serve. Wraps the protected shell, so a new route never needs its
 *  own guard. */
export function EnterpriseModeRedirect({ children }) {
  const mode = useSelector((state) => state.session.mode);
  const { pathname } = useLocation();
  if (mode === 'enterprise' && !isEnterprisePath(pathname)) return <Navigate to="/enterprise" replace />;
  return children;
}
